// import ArchiveIcon from '@mui/icons-material/Archive';
import EmptyCircleIcon from '@mui/icons-material/TripOrigin';
import HalfCircleIcon from '@mui/icons-material/Tonality';
import CircleIcon from '@mui/icons-material/Circle';
import CancelIcon from '@mui/icons-material/NotInterested';
import TrashIcon from '@mui/icons-material/Delete';

import config from '../../config/config';

const getIcon = (status) => {
  switch (status) {
    case 'NEW':
      return () => <EmptyCircleIcon color='warning' style={{fontSize: '1.1rem'}}/>;
    case 'CREATED_ACCOUNT':
      return () => <HalfCircleIcon style={{fontSize: '1.1rem', color: config().colors.teal}}/>;
    case 'COMPLETED_SIGNUP':
      return () => <HalfCircleIcon style={{fontSize: '1.1rem', color: config().colors.deepTeal}}/>;
    case 'LOST':
      return () => <CancelIcon color='error' style={{fontSize: '1.1rem'}}/>;
    case 'SCHEDULED':
      return () => <CircleIcon style={{fontSize: '1.1rem', color: config().colors.blue}}/>;
    case 'EVALUATED':
      return () => <CircleIcon color='success' style={{fontSize: '1.1rem'}}/>;
    case 'ARCHIVED':
      return () => <TrashIcon style={{fontSize: '1.1rem', color: config().colors.muted}}/>;
    case 'ACTIVE':
      return () => <CircleIcon color='success' style={{fontSize: '1.1rem'}}/>;
    default:
      return () => <CircleIcon color='default' style={{fontSize: '1.1rem'}}/>;
  }
};

const LeadIcon = ({status, ...props}) => {
  const Icon = getIcon(status);
  return <Icon {...props} />;
};

export default LeadIcon;